import moment from 'moment'
import Vue from 'vue'

export default {
  data() {
    return {
      languagesMap: {
        'ces': 'cs',
        'slk': 'sk',
        'eng': 'en',
        'deu': 'de'
      }
    }
  },
  computed: {
    formatDate() {
      return value => {
        if (value) {
          return `
                        ${moment.unix(value).format('YYYY-MM-DD')}
                        <span>
                            ${moment.unix(value).format('HH:mm')}
                        </span>
                        `
        }
      }
    },
    formatDateAdvanced() {
      return value => {
        if (value) {
          const currentTimestamp = moment()
          const date = this.formatTimestampToDateTime(value)

          if (date.isSame(currentTimestamp, 'day')) {
            return date.format(`[${this.$gettext('dnes v')}] HH:mm`)
          }
          if (date.isSame(currentTimestamp.clone().subtract(1, 'day'), 'day')) {
            return date.format(`[${this.$gettext('včera v')}] HH:mm`)
          }
          if (date.isSame(currentTimestamp.clone().add(1, 'day'), 'day')) {
            return date.format(`[${this.$gettext('zítra v')}] HH:mm`)
          }
          if (date.isSame(currentTimestamp, 'week')) {
            return date.format('ddd D. M.')
          }
          if (date.isSame(currentTimestamp, 'year')) {
            return date.format('D. M.')
          }

          return date.format('D. M. YYYY')
        }
      }
    },
    formatDateBroadcast() {
      return value => {
        if (value) {
          const currentTimestamp = moment()
          const date = this.formatTimestampToDateTime(value)
          const today = currentTimestamp.isSame(date, 'day')
          return date.format(today ? `HH:mm, [${this.$gettext('dnes')}] D. M.` : 'HH:mm, ddd D. M.')
        }
      }
    },
    formatDateEpg() {
      return value => {
        if (value) {
          const currentTimestamp = moment()
          const date = this.formatTimestampToDateTime(value)
          const today = currentTimestamp.isSame(date, 'day')
          return date.format(today ? `[${this.$gettext('dnes')}] D. M. HH:mm` : 'ddd D. M. HH:mm')
        }
      }
    },
    formatDateCalendar() {
      return value => {
        if (value) {
          return value
        }
      }
    }
  },
  methods: {
    formatTimestampToDateTime(value) {
      return moment.unix(value)
    }
  }

}
